import { styled } from "styled-components";

export const LoyaltyGeneralDetailsContainer = styled.div`
    .form-container {
        display: flex;
        align-items: flex-start;

        .responsive-input {
            max-width: 32vw;
        }

        @media (max-width: 575.98px) {
            display: unset;
        }
    }
`;
